export default "__VITE_ASSET__DtlqUITX__"